module.exports = __webpack_public_path__ + "img/wrapbg9.a90cc663.png";